import { render, staticRenderFns } from "./mobile_approval.vue?vue&type=template&id=36c2fc89&scoped=true"
import script from "./mobile_approval.vue?vue&type=script&lang=js"
export * from "./mobile_approval.vue?vue&type=script&lang=js"
import style0 from "./mobile_approval.vue?vue&type=style&index=0&id=36c2fc89&prod&lang=scss&scoped=true"
import style1 from "./mobile_approval.vue?vue&type=style&index=1&id=36c2fc89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2fc89",
  null
  
)

export default component.exports